module.exports = __webpack_public_path__ + "img/write.81ee06f4.png";